import React from 'react';
import './ImpactedPolicyModal.css';
import ClubbedOtpAccordion from '../../ClubbedOtpAccordion/ClubbedOtpAccordion';
import { Close } from '@material-ui/icons';

const ImpactedPolicyModal = ({ handleAccordionExpansion, policyData, handleModal, policyListWithQuestions }) => {

    if (!policyListWithQuestions.length) return null

    const policies = []
    policyData.forEach((policy) => {
        if (policyListWithQuestions.includes(policy.policyNumber)) {
            policies.push(policy)
        }
    })

    console.log({ policyListWithQuestions, policies })
    if (!policies.length) return null
    return (
        <div className='impacted-policy-modal-ovrly'>
            <div className='impacted-policy-modal-wrapper'>
                <div className='impacted-policy-modal-header'>
                    <div className='mdl-clse-btn'>
                        <Close fontSize='medium' onClick={() => handleModal(false)} />
                    </div>
                    <div className='mdl-heading'>
                        <p>Impacted Policies</p>
                    </div>
                </div>
                <div className="pol-conf-wrapper">
                    {
                        policies.map((data, index) => (
                            <ClubbedOtpAccordion
                                key={index}
                                data={data}
                                handleAccordionExpansion={handleAccordionExpansion}
                                isImpactedPolicyScreen={true}
                            />
                        ))
                    }
                </div>
            </div>
        </div>
    )
}

export default ImpactedPolicyModal
